import dashboardService, { DashboardDateRange } from "@/services/dashboard";
import { useQuery } from "@tanstack/react-query";

export default function useDashboardOverview(range: DashboardDateRange) {
  return useQuery(["merchant-dashboard-overview", range], () =>
    dashboardService.getOverview({ ...range, topCount: 5 })
  );
}
